module.exports = __webpack_public_path__ + "static/media/PrinceOfThePalisades.6d275317.jpg";